module.exports = __webpack_public_path__ + "static/media/grimaldi.f4f8361a.svg";